module.exports = __webpack_public_path__ + "static/media/spinner.0bde9947.gif";